import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2ki6r755: FaireBrandEntity = {
  token: "b_2ki6r755",
  type: "brand",
  name: "JOY DRAVECKY JEWELRY",
  avatarUrl:
    "https://cdn.faire.com/fastly/dcf36c12d1b088b7b70888cdca5282744821dbbe4e01ee3b2b5b65ba9391a197.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/94d24ea1f54485e33a75edadcfb216b9c9439bdcfedfc5387064101082508f0d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/dcf36c12d1b088b7b70888cdca5282744821dbbe4e01ee3b2b5b65ba9391a197.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/94d24ea1f54485e33a75edadcfb216b9c9439bdcfedfc5387064101082508f0d.png",
  location: "Scottsdale, AZ, USA",
  minimumOrderDollars: 205,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Joy Dravecky Jewelry is a faith-inspired, contemporary jewelry brand known for timeless, everyday pieces with meaningful design and strong sell-through. Blending a modern aesthetic with vintage-inspired details, with a focus on quality, durability, and approachable pricing—ideal for boutiques and gift retailers.\n\nFounded by Joy Dravecky as a creative outlet during early motherhood.\n\nEach piece is designed to be wearable, gift-able, and layer-friendly, encouraging repeat purchases and higher AOV. Inspired by faith, life moments, and travel, our jewelry connects emotionally with customers while maintaining a timeless, elevated look.\n\nJoy Dravecky Jewelry exists to create pieces that are beautiful, meaningful, and made to be worn with love.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:44:59.569Z",
    importedBy: "entity-db-cli",
  },
};
